import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * QAHubCTA — reusable call-to-action used inline (after the lead) and at
 * the foot of every /q/:state/:slug page. Takes the entry's contextual
 * line and renders the standard 3-link CTA: primary register, secondary
 * pricing, tertiary home (How TenantTrail works).
 *
 * Visual: matches the existing card / button conventions on /q/:slug and
 * /pricing. NO new visual primitives.
 */
export default function QAHubCTA({ contextual, variant = "inline" }) {
  return (
    <div
      className={`card border-l-4 border-l-[#1B6C62] ${variant === "footer" ? "mt-12" : "my-6"}`}
      data-testid={`qa-hub-cta-${variant}`}
    >
      {contextual && (
        <p className="text-sm text-[#0D2B52] mb-4 leading-relaxed font-serif" data-testid="qa-hub-cta-contextual">
          {contextual}
        </p>
      )}
      <div className="flex flex-wrap items-center gap-3">
        <Link
          to="/register"
          className="btn-primary inline-flex items-center gap-2 text-sm"
          data-testid="qa-hub-cta-register"
        >
          Start free <ArrowRight size={14} strokeWidth={1.75} />
        </Link>
        <span className="text-xs text-[#6B7280] font-mono">no card needed</span>
        <span className="text-xs text-[#9CA3AF]">·</span>
        <Link
          to="/pricing"
          className="text-sm text-[#1B6C62] hover:underline font-serif"
          data-testid="qa-hub-cta-pricing"
        >
          See plans
        </Link>
        <span className="text-xs text-[#9CA3AF]">·</span>
        <Link
          to="/"
          className="text-sm text-[#6B7280] hover:text-[#1A1A1A] font-serif"
          data-testid="qa-hub-cta-home"
        >
          How TenantTrail works
        </Link>
      </div>
    </div>
  );
}
